import { createProvideInject } from '@collector/shared-ui'

import { PitchIncidentsConfig } from '../configuration'

export const [providePitchIncidentsConfig, injectPitchIncidentsConfig] =
  createProvideInject<PitchIncidentsConfig>('pitchIncidentsConfig')
